<template>
  <base-dialog-confirmation
    :model-value="boundValue"
    :prompt="prompt"
    :confirm-text="removeText"
    confirm-color="red"
    @update:model-value="emitBoundValue"
    @confirm="confirm"
    @cancel="cancel"
  ></base-dialog-confirmation>
</template>

<script>
import modelValueCompat from '@/mixins/modelValueCompat';

export default {
  name: 'BaseDialogDeleteConfirmation',

  mixins: [modelValueCompat],

  inheritAttrs: false,

  props: {
    prompt: {
      type: String,
      default: 'Do you really want to do this?',
    },
    removeText: {
      type: String,
      default: 'Remove',
    },
  },

  emits: ['update:modelValue', 'input', 'removed'],

  methods: {
    confirm() {
      this.$emit('removed', this.boundValue);
    },

    cancel() {
      this.emitBoundValue(null);
    },
  },
};
</script>
